import { z } from 'zod';

// Service Request DTO
export const CreateProductLinkServiceRequestDtoSchema = z.object({
  productId: z.string().min(1, '상품 ID는 필수입니다'),
});

export type CreateProductLinkServiceRequest = z.infer<
  typeof CreateProductLinkServiceRequestDtoSchema
>;

// Service Response DTO - API Layer와 분리된 독립적인 DTO
export const CreateProductLinkServiceResponseDtoSchema = z.object({
  link: z.string().url('올바른 URL 형식이어야 합니다'),
  isCurator: z.boolean(),
});

export type CreateProductLinkServiceResponse = z.infer<
  typeof CreateProductLinkServiceResponseDtoSchema
>;
